// extracted by mini-css-extract-plugin
export default {"image":"QmWpw2"};